import { components } from "@/__openapi__/backend/schema";

/**
 * Internal model enum used across the app.
 * Values map to the API's SessionConfigVariant.
 */
export enum ChatModel {
  Auto = "STANDARD",
  Sonnet45 = "CLAUDE_SONNET_4_5",
  Sonnet = "CLAUDE_SONNET_4_6",
  GPT = "GPT_5_2",
  GPT53 = "GPT_5_3",
  GPT54 = "GPT_5_4",
  Gemini = "GEMINI_3_FLASH",
  Gemini31Pro = "GEMINI_3_1_PRO",
}

export enum ChatModelFamily {
  Auto = "Standard",
  Anthropic = "Anthropic",
  OpenAI = "OpenAI",
  Google = "Google",
}

const CHAT_MODEL_TO_FAMILY: Record<ChatModel, ChatModelFamily> = {
  [ChatModel.Auto]: ChatModelFamily.Auto,
  [ChatModel.Sonnet45]: ChatModelFamily.Anthropic,
  [ChatModel.Sonnet]: ChatModelFamily.Anthropic,
  [ChatModel.GPT]: ChatModelFamily.OpenAI,
  [ChatModel.GPT53]: ChatModelFamily.OpenAI,
  [ChatModel.GPT54]: ChatModelFamily.OpenAI,
  [ChatModel.Gemini]: ChatModelFamily.Google,
  [ChatModel.Gemini31Pro]: ChatModelFamily.Google,
};

export function getChatModelFamily(model: ChatModel): ChatModelFamily {
  return CHAT_MODEL_TO_FAMILY[model];
}

export type WebClipModelKind = components["schemas"]["WebClipIntegrationModelKind"];

const CHAT_MODEL_TO_WEB_CLIP: Record<ChatModel, WebClipModelKind> = {
  [ChatModel.Auto]: "AUTO",
  [ChatModel.Sonnet45]: "CLAUDE_SONNET_4_5",
  [ChatModel.Sonnet]: "CLAUDE_SONNET_4_6",
  [ChatModel.GPT]: "GPT_5_2",
  [ChatModel.GPT53]: "GPT_5_3",
  [ChatModel.GPT54]: "GPT_5_4",
  [ChatModel.Gemini]: "GEMINI_3_FLASH",
  [ChatModel.Gemini31Pro]: "GEMINI_3_1_PRO",
};

const WEB_CLIP_TO_CHAT_MODEL: Record<string, ChatModel> = {
  AUTO: ChatModel.Auto,
  CLAUDE_SONNET_4_5: ChatModel.Sonnet45,
  CLAUDE_SONNET_4_6: ChatModel.Sonnet,
  GPT_5_2: ChatModel.GPT,
  GPT_5_3: ChatModel.GPT53,
  GPT_5_4: ChatModel.GPT54,
  GEMINI_3_FLASH: ChatModel.Gemini,
  GEMINI_3_1_PRO: ChatModel.Gemini31Pro,
};

export function chatModelToWebClip(model: ChatModel): WebClipModelKind {
  return CHAT_MODEL_TO_WEB_CLIP[model];
}

export function webClipToChatModel(kind: string | null | undefined): ChatModel {
  if (!kind) return ChatModel.Auto;
  return WEB_CLIP_TO_CHAT_MODEL[kind] ?? ChatModel.Auto;
}
